import script from "./OneRock.vue?vue&type=script&setup=true&lang=js"
export * from "./OneRock.vue?vue&type=script&setup=true&lang=js"

import "./OneRock.vue?vue&type=style&index=0&id=67ebbba8&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ebbba8"]])

export default __exports__